module.exports = __webpack_public_path__ + "img/6f199df701e24cf29bcba4cc18038578.72c83252.jpg";